import { render, staticRenderFns } from "./ZTree.vue?vue&type=template&id=23fee3ec&scoped=true"
import script from "./ZTree.vue?vue&type=script&lang=js"
export * from "./ZTree.vue?vue&type=script&lang=js"
import style0 from "./ZTree.vue?vue&type=style&index=0&id=23fee3ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fee3ec",
  null
  
)

export default component.exports